import React, { useEffect, useRef } from 'react'
import Member from './Member'
import { TEAM } from '../helpers/constants'
import styles from '../ArtAdvisory.module.scss'

const Component = () => {
  const teamRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    // setTimeout necessary to avoid layout shift and the link scroll to a wrong section
    setTimeout(() => {
      if (teamRef.current && location.href.includes('#team')) {
        teamRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center',
        })
      }
    }, 500)
  }, [])

  return (
    <div className={styles.team} id='team' ref={teamRef}>
      <h3 className={`${styles.teamTitle} defaultTypographyH3`}>Meet Our Advisory Team</h3>
      <div className={styles.memberSection}>
        {TEAM.map((teamMember, index) => (
          <Member data={teamMember} key={index} />
        ))}
      </div>
    </div>
  )
}

export default Component
